import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

export default new VueRouter({
     routes: [
       {
         path: '/',
         redirect: '/mutualEvaluation'
       },
       {
         path:'/',
         component:resolve => require(['@/page/home/Home'], resolve),
         children:[
          {
            path: '/ChildPage',
            component:resolve => require(['@/page/home/ChildPage'], resolve),
          },
          {
            path: '/roleSetting',
            component:resolve => require(['@/page/leader/RoleSetting'], resolve),
          },
          {
            path: '/deInforSett',
            component:resolve => require(['@/page/department/deInforSett'], resolve),
          },
          {
            path: '/deInforSettBase',
            component:resolve => require(['@/page/department/deInforSettBase'], resolve),
          },
          {
            path: '/demUtualEvaluaSett',
            component:resolve => require(['@/page/department/demUtualEvaluaSett'], resolve),
          },
          {
            path: '/deDataImpor',
            component:resolve => require(['@/page/department/deDataImpor'], resolve),
          },
          {
            path: '/404',
            component: resolve => require(['@/page/error/404'], resolve),
          },
          {
            name: 'AssessFormPage',
            path: '/AssessFormPage',
            component:resolve => require(['@/page/assessFormWrite/AssessFormPage'], resolve),
          },
          {
            path: '/setAssessFormWrite',
            component:resolve => require(['@/page/assessFormWrite/SetAssessFormWrite'], resolve),
          },
          {
            path: '/assessFormSetting',
            component:resolve => require(['@/page/assessFormSetting/assessFormTable'], resolve),
          },
          {
            path: '/customAssess',
            component:resolve => require(['@/page/assessFormSetting/CustomAssess'], resolve),
          },
          {
            path: '/mutualEvaluation',
            component:resolve => require(['@/page/mutualEvaluation/mutualEvaluation'], resolve),
          },
          {
            path: '/reportForms',
            component:resolve => require(['@/page/reportForms/ReportForms'], resolve),
          },
          {
            path: '/departmentReportForms',
            component:resolve => require(['@/page/reportForms/DepartmentReportForms'], resolve),
          },
          {
            path: '/lowGradeReportForms',
            component:resolve => require(['@/page/reportForms/LowGradeReportForms'], resolve),
          },
         ]
      },
      {
        path: '/login',
        name: 'login',
        component:resolve => require(['@/page/login/Login'], resolve),
      },
      {
        path: '*',
        redirect: '/404'
      }
     ],
})